<template>
  <div class="geoproceso-form form-section">
    <!-- MODO DE SELECCIÓN -->
    <GeoprocesoSelectorModo v-model="otrasCapas" @input="onModeChange" />

    <!-- SELECCIÓN DE CAPA (Si aplica) -->
    <GeoprocesoSelectorCapa 
      v-model="capaOtrasSeleccionada"
      :otrasCapas="otrasCapas"
      :tipoInfluencia="'Lineal'"
      :distancias="distancias"
      :dissolve="dissolve"
      @selection-complete="onSelectionComplete"
    />

    <!-- HERRAMIENTAS DE DIBUJO (Si aplica) -->
    <div v-if="!otrasCapas">
      <label>Dibujar Polilínea</label>
      <button class="draw-btn" title="Dibujar línea" @click="drawLine">✎</button>
    </div>

    <!-- 🔹 Inputs dinámicos -->
    <div v-if="radioSeleccionado" class="distancias">
      <label>Radios de influencia: (m)</label>
      <div class="distancia-inputs">
        <input
          v-for="(dist, index) in distancias"
          :key="index"
          type="number"
          :value="dist"
          min="1"
          placeholder="Distancia"
          @input="updateDistancia(index, $event.target.value)"
        />
      </div>
    </div>

    <GeoprocesoOpcionesGenerales
      :capas.sync="capas"
      :metodo.sync="metodo"
      :capasSeleccionadas.sync="capasSeleccionadas"
      :dissolve.sync="dissolve"
    />
  </div>
</template>

<script>
import GeoprocesoBaseMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoBaseMixin';
import GeoprocesoDistanciaMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoDistanciaMixin';
import GeoprocesoOpcionesGenerales from '@/components/mapTools/geoprocessings/forms/GeoprocesoOpcionesGenerales';
import GeoprocesoSelectorModo from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorModo';
import GeoprocesoSelectorCapa from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorCapa';

export default {
  name: 'InfluenciaLinealForm',
  components: { GeoprocesoOpcionesGenerales, GeoprocesoSelectorModo, GeoprocesoSelectorCapa },
  mixins: [GeoprocesoBaseMixin, GeoprocesoDistanciaMixin],
  data() {
    return {
      capaOtrasSeleccionada: '',
      seleccionInfo: null,
    };
  },
  methods: {
    drawLine() {
      this.$emit('changeDrawType', { name: 'Línea', code: 'LineString' });
    },
    currentPayload() {
      return {
        ...this.getCommonPayload(),
        radioSeleccionado: this.radioSeleccionado,
        distancias: this.distancias.filter((v) => v > 0),
        capaOtrasSeleccionada: this.capaOtrasSeleccionada,
        seleccionInfo: this.seleccionInfo,
      };
    },
    onSelectionComplete(data) {
      this.seleccionInfo = data;
      this.emitState();
    },
  },
};
</script>

<style src="./_geoproceso-forms.css"></style>
<style scoped>
.draw-btn {
  width: 38px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background: #333;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  margin-bottom: 8px;
}
.draw-btn:hover { background: #444; }
.draw-btn:active { background: #555; transform: scale(0.97); }
</style>
